export const MEDICAL_BOARD_ROUTE_NAME = 'medicalBoards';
export const MEDICAL_BOARD_ROUTES = {
  get: '/medical-boards/{providerCategoryId}',
};
